import { render, staticRenderFns } from "./ymsLogistics.vue?vue&type=template&id=06f8f682&scoped=true"
import script from "./ymsLogistics.vue?vue&type=script&lang=js"
export * from "./ymsLogistics.vue?vue&type=script&lang=js"
import style0 from "./ymsLogistics.vue?vue&type=style&index=0&id=06f8f682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8f682",
  null
  
)

export default component.exports